import mainStore from "store/mainStore";
import { getStorage } from "store/local";

const getProduct = (value) => {
  const search = ["reference", "ilike", `%${value}%`];
  return search;
};

const getCategoryUom = (value, rec) => {
  let categoryUom = rec.uom.category;
  const search = [["category", "=", categoryUom]];
  return search;
};

const onChangeProduct = async (record, storeRec) => {
  const activeRecord = mainStore.getState().record;
  console.log(record.product, "activeRecord");

  if (record.product) {
    const uom = record.product["default_uom."];
    console.log(uom, "asdad");

    if (uom) {
      record.unit = uom;
      storeRec.unit = uom.id;
    }

    if (activeRecord) {
      record.from_location = activeRecord.from_location;
      record.to_location = activeRecord.to_location;
      storeRec.from_location = activeRecord?.from_location?.id;
      storeRec.to_location = activeRecord?.to_location?.id;
      storeRec.unit_price = record.product.list_price;
      record.note = record.product.reference;
    }
  } else {
    record.unit = null;
    storeRec.unit = null;
    storeRec.from_location = null;
    storeRec.to_location = null;
    storeRec.unit_price = 0;
  }
};

export default {
  model: "stock.move",
  row_selectable: false,
  target: "shipment",
  table_action: ["add", "edit"],
  form_action: ["add", "delete", "edit"],
  webfields: {
    product: {
      type: "many2one",
      model: "product.product",
      // recSearch: getProduct,
      withChange: onChangeProduct,
      required: true,
      attrs: [
        "id",
        "default_uom.name",
        "default_uom.category",
        "name",
        "list_price",
        "uom",
        "rec_name",
        "reference",
      ],
      reference: true,
    },
    quantity: {
      type: "float",
      decimalPlaces: 1,
      default: 1,
      required: true,
      readOnly: true,
    },
    uom: { type: "many2one", model: "product.uom", readOnly: false },
    unit: {
      type: "many2one",
      model: "product.uom",
      recSearch: getCategoryUom,
    },
    company: {
      default: getStorage("ctxSession") && getStorage("ctxSession").company,
    },
    currency: {
      default: getStorage("ctxSession") && getStorage("ctxSession").currency,
    },
    from_location: {
      type: "many2one",
      model: "stock.location",
    },
    to_location: {
      type: "many2one",
      model: "stock.location",
    },
    state: {
      type: "char",
      translate: true,
      readOnly: true,
    },
    note: {
      type: "char",
      translate: true,
      readOnly: true,
    },
  },
  webtree: [
    { name: "product", width: "60%" },
    { name: "unit", width: "10%" },
    { name: "quantity", width: "20%" },
    { name: "state", width: "20%" },
  ],
  webform: [
    { name: "product" },
    { name: "quantity" },
    { name: "unit" },
    // { name: "note" },
  ],
};
